var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('HeadView'),_vm._v(" "),_c('main',{staticClass:"container-fluid"},[_c('router-view',{staticClass:"container"})],1),_vm._v(" "),_c('back-to-top',{staticClass:"btn-bottom",attrs:{"visibleoffset":"50"}},[_c('i',{staticClass:"fas fa-chevron-up"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0464616b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/full.vue
// module id = 1170
// module chunks = 6